/**
 * StoreBadges — App Store + Google Play download buttons.
 * Hidden inside the native shell (no store links in-app).
 */
import React from "react";
import { AppleLogoIcon as AppleLogo, GooglePlayLogoIcon as GooglePlayLogo } from "@phosphor-icons/react";
import { isNativeApp } from "@/lib/nativeBridge";
import { track } from "@/lib/analytics";

export const APP_STORE_URL =
  "https://apps.apple.com/us/app/armstrong-k9-registry/id6790544132";
export const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.armstrongk9registry";

export default function StoreBadges({ tone = "dark", source = "unknown", className = "" }) {
  if (isNativeApp()) return null;
  const badge =
    tone === "dark"
      ? "bg-white/10 border border-white/25 text-white hover:bg-white hover:text-ink"
      : "bg-ink border border-ink text-white hover:bg-crimson hover:border-crimson";
  const sub = tone === "dark" ? "opacity-75" : "opacity-70";
  const item = (href, Icon, top, bottom, testid, store) => (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      onClick={() => track("store_badge_click", { store, source })}
      className={`inline-flex items-center gap-2.5 rounded-xl px-4 py-2 transition-colors ${badge}`}
      data-testid={testid}
    >
      <Icon size={24} weight="fill" className="shrink-0" />
      <span className="leading-tight text-left">
        <span className={`block text-[9px] uppercase tracking-[0.14em] font-semibold ${sub}`}>{top}</span>
        <span className="block text-[14px] font-bold -mt-0.5">{bottom}</span>
      </span>
    </a>
  );
  return (
    <div className={`flex items-center gap-3 flex-wrap ${className}`} data-testid={`store-badges-${source}`}>
      {item(APP_STORE_URL, AppleLogo, "Download on the", "App Store", `store-badge-appstore-${source}`, "apple")}
      {item(PLAY_STORE_URL, GooglePlayLogo, "Get it on", "Google Play", `store-badge-play-${source}`, "google")}
    </div>
  );
}
